import React, { useState, useRef, useEffect, useCallback } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";
import { useFile } from "@redux/files";
import { useAdvertisement } from "@redux/advertisement";
import images from "@app/images";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DefaultLabel } from "@assets/label";
import {
  OutlinedInputRightAdornment,
  OutlinedInputDefault,
} from "@assets/TextField";
import { GreyLightButton } from "@assets/buttons";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  priceResult,
  adminValueCheck,
  etcfilterResult,
} from "@assets/utils/check";
import { useMenuState } from "@assets/contexts/MenuContext";
import ImpressionsCpp from "./ImpressionsCpp";
import ImpressionsCpm from "./ImpressionsCpm";
import {
  AdFilter,
  AdUser,
  OpenType,
  BannerBaseData,
  OpenTypeLeft,
  SymptomList,
  DiseaseList,
} from "@components/CompAd/CompAdAdd/adTypeList";
import UrlInputByOpenType from "@components/CompAd/CompAdAdd/UrlInputByOpenType";
import ConfigRedux from "@redux/config";
import { Checkbox, FormControl, MenuItem, Select } from "@mui/material";

const TitleMaxLength = 20;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xl: 897, lg: 897, md: 897, sm: 897, xs: "calc(100% - 16px)" },
  height: { xl: 804, lg: 804, md: 804, sm: 804, xs: "calc(100% - 32px)" },
  borderRadius: "24px",
  overflow: "auto",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: 6.875,
};

const Item = styled(Grid)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Input = styled("input")({
  display: "none",
});

const newBanner = { ...BannerBaseData };
const AdDialog = ({
  open,
  target,
  onClose,
  onADDELETE,
  onNewRows,
  onNewRowsFilter,
}) => {
  const value = useMenuState();
  const advertisement = useAdvertisement();
  const [val, setVal] = useState(target);
  const [index, setIndex] = useState(0);
  const [errorData, setErrorData] = useState({
    start: true,
    end: true,
  }); // 날짜 체크
  const inputRef = useRef(null);
  const telemAdImgRef = useRef(null);
  const files = useFile();
  const [telemAdImg, setTelemAdImg] = useState("");
  //시작일
  let viewDateStart = dayjs(val.view_date_start).format("YYYY-MM-DD HH:mm:00");
  //종료일
  let viewDateEnd = dayjs(val.view_date_end).format("YYYY-MM-DD HH:mm:00");
  //새로운 배너
  // console.log(val);
  // 이미지 추가
  const handleAddImage = (e) => {
    const { value } = e.target;
    const newData = (banner, nd) => {
      let arr = banner.map((d, i) => {
        if (i === index) {
          return { ...d, img_url: nd };
        }
        return d;
      });
      return arr;
    };
    if (value !== "" && value) {
      files.uploadAdBanner(e.target.files[0], (data, response) => {
        if (response.status === 200) {
          if (data.error) {
            alert(data.error.message);
          } else {
            const prevVal = val;
            const dataListCheck = data.result?.[0]?.url || data.list?.[0]?.url || data.url;
            if (dataListCheck) {
              setVal({
                ...val,
                banners: newData(prevVal.banners, dataListCheck),
              });
            }
          }
        } else {
          alert("에러가 발생하였습니다.");
        }
      });
    }
  };

  // 배너 추가
  const handleBannerAdd = useCallback(() => {
    setVal({
      ...val,
      banners: [...val.banners, newBanner],
    });
    setIndex(val.banners.length);
  }, [val]);

  // 배너 포커스 변경
  const handleBannerTargetChange = (typeCase = "prev") => {
    setIndex(typeCase === "prev" ? index - 1 : index + 1);
  };

  // 배너 삭제
  const handleBannerDelete = () => {
    const defaultAdId = val.banners[0].ad_id;
    if (index === 0) {
      // 1. 현재 배너의 갯수가 1개인경우
      if (val.banners.length === 1) {
        const adIdUseNewBanner = {
          ad_id: defaultAdId,
          img_url: "",
          link_url: "",
          link_url_i: "",
        };
        setVal({
          ...val,
          banners: [adIdUseNewBanner],
        });
        // 2. 현재 배너의 갯수가 2개이상인데 첫번째를 삭제하는경우
      } else {
        const filterData = val.banners.filter((data, i) => {
          return i !== 0;
        });
        const mapData = filterData.map((data, i) => {
          if (i === 0) {
            data.ad_id = defaultAdId;
          }
          return data;
        });
        setVal({
          ...val,
          banners: mapData,
        });
      }
      // 3. 현재 배너의 갯수가 2개이상인데 첫번째 이외를 삭제하는경우.
    } else {
      const filterData = val.banners.filter((data, i) => {
        return i !== index;
      });
      if (filterData.length === 0) {
        setIndex(0);
        setVal({
          ...val,
          banners: [newBanner],
        });
      } else {
        if (index !== 0) {
          setIndex(index - 1);
        }
        setVal({
          ...val,
          banners: filterData,
        });
      }
    }
  };

  //날짜 변경
  const handleDateChange = (newValue, cheker = "start") => {
    if (cheker === "start") {
      setVal({
        ...val,
        view_date_start: dayjs(newValue).format("YYYY-MM-DD HH:mm:ss"),
      });
    } else {
      setVal({
        ...val,
        view_date_end: dayjs(newValue).format("YYYY-MM-DD HH:mm:ss"),
      });
    }
  };
  //수정완료 버튼
  const handleUpdate = () => {
    let result = val;
    if (String(result.ad_type) === "9") {
      result = { ...result, ad_filter: null };
    }
    if (!result.title || result.title === "") {
      alert("광고상품을 입력해 주세요.");
      return false;
    } else {
      if (result.is_cpm === "Y") {
        if (!result.cpm_limit || result.cpm_limit === 0) {
          alert("보장 노출 수를 입력해주세요.");
          return false;
        }
        result.cpm_limit = isNaN(result.cpm_limit)
          ? parseInt(result.cpm_limit.replace(/,/g, ""))
          : result.cpm_limit;
        let check = /^[0-9]+$/;

        if (!check.test(result.cpm_limit)) {
          alert("노출수는 숫자만 입력 가능합니다.");
          return false;
        }
      }
      advertisement.update(result, (data, response) => {
        if (response.status === 200) {
          if (data.error) {
            alert(data.error.message);
          } else {
            if (data.result) {
              // ad_type 8: 배너 이미지 config 저장
              // V2 키를 쓰는 이유: 구키(SCREENGUIDE_TELEM_AD_IMG)는 인앱 연동이 없는 구버전 앱의
              // 배너 노출 게이트다. 구버전은 V2 키를 모르므로 소재를 등록해도 배너가 뜨지 않는다.
              // 값이 비면 " "로 저장하는 이유: /config/set이 빈 문자열을 param_error로 거부한다
              // (ext-koa Utils.checkNullOrEmpty). 삭제 버튼은 로컬 상태만 비우므로 이 저장이 곧 끄기다.
              // 앱은 이 값을 trim 후 판정하므로 " "는 미노출로 처리된다.
              if (result.ad_type == 8) {
                ConfigRedux.setAsync(
                  "SCREENGUIDE_TELEM_AD_IMG_V2",
                  telemAdImg || " "
                );
              }
              alert("수정완료 되었습니다.");
              onNewRows(result);
            } else {
              alert("에러가 발생했습니다. 새로고침이후 이용해주세요.");
            }
          }
        } else {
          alert("에러가 발생하였습니다.");
        }
      });
    }
  };

  const handleChangeCPMLimit = (e) => {
    const data = parseInt(e.target.value.replace(/,/g, ""));
    if (data) {
      setVal({
        ...val,
        cpm_limit: priceResult(parseInt(e.target.value.replace(/,/g, ""))),
      });
    } else {
      setVal({
        ...val,
        cpm_limit: e.target.value === "" ? 0 : val.cpm_limit,
      });
    }
  };

  const handleCurrentChange = (e) => {
    setVal({
      ...val,
      cpm_current: e.target.value,
    });
  };

  useEffect(() => {
    setVal(target);
  }, [target]);

  // 배너 이미지 (ad_type 8): config에서 URL 로드 (저장 키와 동일하게 V2)
  useEffect(() => {
    if (open && target?.ad_type == 8) {
      ConfigRedux.getAsync("SCREENGUIDE_TELEM_AD_IMG_V2").then((v) => {
        setTelemAdImg(v?.trim() || "");
      });
    } else {
      setTelemAdImg("");
    }
  }, [open, target]);

  // 배너 이미지 업로드 (로컬 상태만 변경, 수정완료 시 config 저장)
  const handleTelemAdImgUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    files.uploadAdBanner(file, (data, response) => {
      if (response.status === 200 && !data.error) {
        const url = data.result?.[0]?.url || data.list?.[0]?.url || data.url;
        if (url) setTelemAdImg(url);
      } else {
        alert(data?.error?.message || "에러가 발생하였습니다.");
      }
    });
    e.target.value = "";
  };

  // 배너 이미지 삭제 (로컬 상태만 변경)
  const handleTelemAdImgDelete = () => {
    setTelemAdImg("");
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Grid container justifyContent="space-between" sx={{ mb: 3 }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h2">{val.advertiser_name}</Typography>
          </Box>
          <Box
            sx={{ width: "200px", display: "flex", justifyContent: "flex-end" }}
          >
            <Box
              sx={{
                pt: 0.625,
                pl: 1.25,
                pr: 1.25,
                pb: 0.625,
                ml: 1.5,
                borderRadius: "5px",
                backgroundColor: "#EDF7FE",
              }}
            >
              <Typography color="primary.dark" variant="body">
                {etcfilterResult(val.ad_type)}
              </Typography>
            </Box>
            <Box
              sx={{
                pt: 0.625,
                pl: 1.25,
                pr: 1.25,
                pb: 0.625,
                ml: 1.5,
                borderRadius: "5px",
                backgroundColor: "#FDF1D7",
              }}
            >
              <Typography color="secondary.dark" variant="body">
                {val.is_cpm === "N" ? "CPP" : "CPM"}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid container spacing={5}>
          <Grid item lg={6} md={6} xs={6}>
            <Item container alignItems="flex-start" direction="column">
              <Box sx={{ mb: 2, width: "100%" }}>
                <DefaultLabel name="광고상품" />
                {/* <OutlinedInputRightAdornment */}
                <OutlinedInputDefault
                  value={val.title}
                  onChange={(e) =>
                    setVal({
                      ...val,
                      title: e.target.value?.length > 999 ? e.target.value.substring(0, 999) : e.target.value,
                    })
                  }
                  name={"name"}
                  krName={"광고상품"}
                  disabled={!adminValueCheck(value.user.ADMIN)}
                  // adorment={`${val.title?.length || 0} / ${TitleMaxLength}자`}
                />
              </Box>
              {val.ad_type == 7 || val.ad_type == 8 || val.ad_type == 13 || val.ad_type == 14 || val.ad_type == 15 ? (
                <>
                  <Box sx={{ mb: 2, width: "100%" }}>
                    <DefaultLabel name="설명" />
                    {/* <OutlinedInputRightAdornment */}
                    <OutlinedInputDefault
                      value={val.extra?.desc || ""}
                      onChange={(e) =>
                        setVal({
                          ...val,
                          extra: { ...val.extra, desc: e.target.value?.length > 20 ? e.target.value.substring(0, 999) : e.target.value },
                        })
                      }
                      name={"desc"}
                      krName={"설명"}
                      disabled={!adminValueCheck(value.user.ADMIN)}
                      // adorment={`${val.extra?.desc?.length || 0} / 20자`}
                    />
                  </Box>
                  {val.ad_type == 13 || val.ad_type == 14 ? (
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="필수기재 문구 (보험 등)" />
                      <OutlinedInputDefault
                        value={val.extra?.caption || ""}
                        onChange={(e) =>
                          setVal({
                            ...val,
                            extra: { ...val.extra, caption: e.target.value },
                          })
                        }
                        name={"caption"}
                        krName={"필수기재 문구"}
                        disabled={!adminValueCheck(value.user.ADMIN)}
                        multiline
                        minRows={2}
                      />
                      <Typography variant="caption" color="#9A9A9B" sx={{ mt: 0.5, display: "block" }}>
                        광고심의제한 문구. 엔터로 줄바꿈됨.
                      </Typography>
                    </Box>
                  ) : null}
                  {val.ad_type == 8 || val.ad_type == 13 || val.ad_type == 14 || val.ad_type == 15 ? (
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="GA 이벤트 이름" />
                      <OutlinedInputRightAdornment
                        value={val.extra?.fb_event_click || ""}
                        onChange={(e) => {
                          if (e.target.value.length > 40) {
                          } else {
                            setVal({
                              ...val,
                              extra: { ...val.extra, fb_event_click: e.target.value },
                            });
                          }
                        }}
                        name={"fb_event_click"}
                        disabled={!adminValueCheck(value.user.ADMIN)}
                        adorment={` ${
                          val.extra?.fb_event_click
                            ? val.extra?.fb_event_click.length
                            : 0
                        }/ 40자`}
                      />
                    </Box>
                  ) : null}
                  {
                    val.ad_type == 7 ? (
                      <Grid
                        container
                        justifyContent="space-between"
                        sx={{ mb: 2, width: "100%" }}
                      >
                        <Box>
                          <DefaultLabel name="포인트" />
                          <OutlinedInputDefault
                            value={val.extra?.point || 0}
                            inputType={"number"}
                            onChange={(e) =>
                              setVal({
                                ...val,
                                extra: { ...val.extra, point: e.target.value },
                              })
                            }
                            name={"point"}
                            krName={"포인트"}
                            disabled={!adminValueCheck(value.user.ADMIN)}
                          />
                        </Box>
                        <Box>
                          <DefaultLabel name="우선순위" />
                          <OutlinedInputDefault
                            value={val.order_num || 0}
                            inputType={"number"}
                            onChange={(e) =>
                              setVal({ ...val, order_num: e.target.value })
                            }
                            name={"order_num"}
                            krName={"우선순위"}
                            disabled={!adminValueCheck(value.user.ADMIN)}
                          />
                        </Box>
                      </Grid>
                    ) : null
                  }
                </>
              ) : null}
              {val.ad_type == 7 || val.ad_type == 8 || val.ad_type == 13 || val.ad_type == 14 || val.ad_type == 15 ? null : (
                <>
                  <Grid
                    container
                    justifyContent="space-between"
                    sx={{ mb: 2, width: "100%" }}
                  >
                    {val.is_cpm === "N" ? (
                      <ImpressionsCpp
                        cpm_limit={val.cpm_limit}
                        click_count={val.click_count}
                        view_count={val.view_count}
                        is_cpm={val.is_cpm}
                        cpm_current={val.cpm_current}
                        onChange={handleChangeCPMLimit}
                      />
                    ) : (
                      <ImpressionsCpm
                        cpm_limit={val.cpm_limit}
                        is_cpm={val.is_cpm}
                        cpm_current={val.cpm_current}
                        value={value}
                        onChange={handleChangeCPMLimit}
                        onCurrentChange={handleCurrentChange}
                        view_count={val.view_count}
                        click_count={val.click_count}
                      />
                    )}
                  </Grid>
                </>
              )}
              <Box sx={{ mb: 2, width: "100%" }}>
                <DefaultLabel name="시작일" />
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DateTimePicker
                    inputFormat={"yyyy-MM-dd HH:mm:ss"}
                    mask={"____-__-__"}
                    disableOpenPicker
                    value={viewDateStart}
                    autoFocus
                    margin="dense"
                    onChange={(e) => handleDateChange(e, "start")}
                    onError={(_, error) => {
                      setErrorData({
                        ...errorData,
                        start: dayjs(error).isValid(),
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        disabled={!adminValueCheck(value.user.ADMIN)}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: 41,
                            m: 0,
                            fontSize: 12,
                            "& .MuiButtonBase-root": {},
                            "& .MuiInputBase-input": {
                              padingRight: 1,
                            },
                          },
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Box>
              <Box sx={{ mb: 2, width: "100%" }}>
                <DefaultLabel name="종료일" />
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DateTimePicker
                    inputFormat={"yyyy-MM-dd HH:mm:ss"}
                    mask={"____-__-__"}
                    disableOpenPicker
                    value={viewDateEnd}
                    autoFocus
                    margin="dense"
                    onChange={(e) => handleDateChange(e, "end")}
                    onError={(_, error) => {
                      setErrorData({
                        ...errorData,
                        end: dayjs(error).isValid(),
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        disabled={!adminValueCheck(value.user.ADMIN)}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: 41,
                            m: 0,
                            fontSize: 12,
                            "& .MuiButtonBase-root": {},
                            "& .MuiInputBase-input": {
                              padingRight: 1,
                            },
                          },
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Box>
              {OpenTypeLeft[String(val.ad_type)]?.length > 0 ? (
                <Box sx={{ mb: 2, width: "100%" }}>
                  <DefaultLabel name="오픈 방식" />
                  <FormControl fullWidth>
                    <Select
                      labelId="open_type"
                      id="open_type"
                      align="left"
                      size="small"
                      sx={{ height: 41 }}
                      value={val.banners[index].open_type}
                      onChange={(e) => {
                        const openType = e.target.value;
                        const nextVal = {
                          ...val,
                          banners: val.banners.map((data, i) => {
                            if (i !== index) return data;
                            const updated = { ...val.banners[i], open_type: openType };
                            if (val.ad_type == 7 || val.ad_type == 8) {
                              updated.link_url = "";
                              updated.link_url_i = "";
                            }
                            return updated;
                          }),
                        };
                        if (val.ad_type == 7) {
                          nextVal.extra = {
                            ...(val.extra || {}),
                            position: {
                              ...(val.extra?.position || {}),
                              fever_tab: {
                                ...(val.extra?.position?.fever_tab || {}),
                                url: "",
                                url_i: "",
                              },
                            },
                          };
                        }
                        setVal(nextVal);
                      }}
                    >
                      {OpenTypeLeft[String(val.ad_type)]?.map((data, index) => (
                        <MenuItem value={data.id} key={data.id}>
                          <Typography
                            variant="body"
                            color="grey.900"
                            fontWeight={400}
                          >
                            {data.text}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              ) : null}
              {val.ad_type == 8 && (
                <Box sx={{ mb: 2, width: "100%" }}>
                  <DefaultLabel name="배너 이미지" />
                  <input
                    accept="image/*"
                    type="file"
                    ref={telemAdImgRef}
                    onChange={handleTelemAdImgUpload}
                    style={{ display: "none" }}
                  />
                  {telemAdImg ? (
                    <Box>
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          height: 127,
                          mt: 1,
                          mb: 1,
                          backgroundColor: "#bebebe",
                          border: "1px solid #c4c4c4",
                          backgroundImage: `url(${telemAdImg})`,
                          backgroundSize: "cover",
                          backgroundPosition: "50% 50%",
                          backgroundRepeat: "no-repeat",
                        }}
                      />
                      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => telemAdImgRef.current?.click()}
                          disabled={!adminValueCheck(value.user.ADMIN)}
                        >
                          변경
                        </Button>
                        <Button
                          variant="outlined"
                          size="small"
                          color="error"
                          onClick={handleTelemAdImgDelete}
                          disabled={!adminValueCheck(value.user.ADMIN)}
                        >
                          삭제
                        </Button>
                      </Stack>
                    </Box>
                  ) : (
                    <Grid
                      container
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        height: 127,
                        mt: 1,
                        mb: 1,
                        backgroundColor: "#F6F6F8",
                        borderRadius: "5px",
                        cursor: adminValueCheck(value.user.ADMIN) ? "pointer" : "default",
                      }}
                      onClick={() => {
                        if (adminValueCheck(value.user.ADMIN)) {
                          telemAdImgRef.current?.click();
                        }
                      }}
                    >
                      <Box sx={{ textAlign: "center" }}>
                        <img src={images.inc_img_plus.default} alt="img_plus" />
                        <Typography variant="body2" fontWeight={500} color="#DDDDDF">
                          이미지 추가
                        </Typography>
                      </Box>
                    </Grid>
                  )}
                </Box>
              )}
            </Item>
            <Grid
              container
              justifyContent="space-between"
              sx={{ mb: 3, width: "100%", pl: 1.25, pr: 1.25 }}
            >
              {AdUser[String(val.ad_type)]?.length > 0 && val.ad_type != 9 ? (
                <Box sx={{ width: "49%" }}>
                  <DefaultLabel name="노출대상" />
                  <FormControl fullWidth>
                    <Select
                      labelId="ad_user"
                      id="ad_user"
                      align="left"
                      size="small"
                      sx={{ height: 41 }}
                      value={val.ad_user}
                      onChange={(e) => {
                        setVal({ ...val, ad_user: e.target.value });
                      }}
                    >
                      {AdUser[String(val.ad_type)]?.map((data, index) => (
                        <MenuItem value={data.id} key={data.id}>
                          <Typography
                            variant="body"
                            color="grey.900"
                            fontWeight={400}
                          >
                            {data.text}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              ) : null}
              {AdFilter[String(val.ad_type)]?.length > 0 && val.ad_type != 9 ? (
                <Box sx={{ width: "49%" }}>
                  <DefaultLabel name="대상 스크린" />
                  <FormControl fullWidth>
                    <Select
                      labelId="ad_filter"
                      id="ad_filter"
                      align="left"
                      size="small"
                      sx={{ height: 41 }}
                      value={val.ad_filter?.[0] || ""}
                      onChange={(e) => {
                        setVal({ ...val, ad_filter: [e.target.value] });
                      }}
                    >
                      {AdFilter[String(val.ad_type)]?.map((data, index) => (
                        <MenuItem value={data.id} key={data.id}>
                          <Typography
                            variant="body"
                            color="grey.900"
                            fontWeight={400}
                          >
                            {data.text}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              ) : null}
            </Grid>
            {val.ad_type == 9 && (
              <Grid container sx={{ mb: 3, width: "100%", pl: 1.25, pr: 1.25 }}>
                <Box sx={{ width: "100%" }}>
                  <DefaultLabel name="이미지 (840x960)" />
                  <label htmlFor="contained-button-file" style={{ display: "block" }}>
                    {adminValueCheck(value.user.ADMIN) && (
                      <Input
                        accept="image/*"
                        id="contained-button-file"
                        multiple
                        type="file"
                        ref={inputRef}
                        onChange={handleAddImage}
                      />
                    )}
                    {val.banners[index] && val.banners[index].img_url ? (
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          width: 175,
                          height: 200,
                          mt: 2,
                          mb: 2,
                          backgroundColor: "#bebebe",
                          border: "1px solid #c4c4c4",
                          backgroundImage: `url(${val.banners[index].img_url})`,
                          backgroundSize: "cover",
                          backgroundPosition: "50% 50%",
                          backgroundRepeat: "no-repeat",
                          cursor: "pointer",
                        }}
                      ></Grid>
                    ) : (
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          width: 175,
                          height: 200,
                          mt: 2,
                          mb: 2,
                          backgroundColor: "#F6F6F8",
                          borderRadius: "5px",
                          cursor: "pointer",
                        }}
                      >
                        <Box sx={{ textAlign: "center" }}>
                          <img src={images.inc_img_plus.default} alt="img_plus" />
                          <Typography variant="body2" fontWeight={500} color="#DDDDDF">
                            이미지 추가
                          </Typography>
                        </Box>
                      </Grid>
                    )}
                  </label>
                </Box>
                <Box sx={{ width: "100%", mt: 2 }}>
                  <DefaultLabel name="이미지명" />
                  <OutlinedInputRightAdornment
                    value={val.banners[index].img_name ? val.banners[index].img_name : ""}
                    onChange={(e) => {
                      if (e.target.value.length > 100) {
                      } else {
                        setVal({
                          ...val,
                          banners: val.banners.map((data, i) => {
                            return i === index
                              ? { ...val.banners[i], img_name: e.target.value }
                              : data;
                          }),
                        });
                      }
                    }}
                    name="img_name"
                    adorment={` ${val.banners[index].img_name ? val.banners[index].img_name.length : 0}/ 100자`}
                    disabled={!adminValueCheck(value.user.ADMIN)}
                  />
                </Box>
              </Grid>
            )}
          </Grid>
          <Grid item lg={6} md={6} xs={6}>
            <Item
              container
              alignItems="flex-start"
              direction="column"
              sx={{
                backgroundColor: "grey.200",
                borderRadius: "15px",
                pt: 2,
                pb: 6,
                pl: 5.25,
                pr: 5.25,
              }}
            >
              {val.ad_type == 4 ? (
                <>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="메세지" />
                      <OutlinedInputRightAdornment
                        value={val.extra?.message || ""}
                        onChange={(e) => {
                          if (e.target.value.length > 100) {
                          } else {
                            setVal({
                              ...val,
                              extra: { ...val.extra, message: e.target.value },
                            });
                          }
                        }}
                        name="message"
                        adorment={` ${
                          val.extra?.message ? val.extra?.message.length : 0
                        }/ 100자`}
                      />
                    </Box>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="버튼 텍스트" />
                      <OutlinedInputRightAdornment
                        value={val.extra?.button_text || ""}
                        onChange={(e) => {
                          if (e.target.value.length > 20) {
                          } else {
                            setVal({
                              ...val,
                              extra: {
                                ...val.extra,
                                button_text: e.target.value,
                              },
                            });
                          }
                        }}
                        name="button_text"
                        adorment={` ${
                          val.extra?.button_text
                            ? val.extra?.button_text.length
                            : 0
                        }/ 20자`}
                      />
                    </Box>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="GA 이벤트 이름" />
                      <OutlinedInputRightAdornment
                        value={val.extra?.fb_event_click || ""}
                        onChange={(e) => {
                          if (e.target.value.length > 40) {
                          } else {
                            setVal({
                              ...val,
                              extra: {
                                ...val.extra,
                                fb_event_click: e.target.value,
                              },
                            });
                          }
                        }}
                        name="fb_event_click"
                        adorment={` ${
                          val.extra?.fb_event_click
                            ? val.extra?.fb_event_click.length
                            : 0
                        }/ 40자`}
                      />
                    </Box>
                  </Grid>
                </>
              ) : val.ad_type == 5 ? (
                <>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="타이틀" />
                      <OutlinedInputRightAdornment
                        value={val.extra?.title || ""}
                        onChange={(e) => {
                          if (e.target.value.length > 20) {
                          } else {
                            setVal({
                              ...val,
                              extra: { ...val.extra, title: e.target.value },
                            });
                          }
                        }}
                        name="title"
                        adorment={` ${
                          val.extra?.title ? val.extra?.title.length : 0
                        }/ 20자`}
                      />
                    </Box>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="메세지" />
                      <OutlinedInputRightAdornment
                        value={val.extra?.message || ""}
                        onChange={(e) => {
                          if (e.target.value.length > 100) {
                          } else {
                            setVal({
                              ...val,
                              extra: { ...val.extra, message: e.target.value },
                            });
                          }
                        }}
                        name="message"
                        adorment={` ${
                          val.extra?.message ? val.extra?.message.length : 0
                        }/ 100자`}
                      />
                    </Box>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="GA 이벤트 이름" />
                      <OutlinedInputRightAdornment
                        value={val.extra?.fb_event_click || ""}
                        onChange={(e) => {
                          if (e.target.value.length > 40) {
                          } else {
                            setVal({
                              ...val,
                              extra: {
                                ...val.extra,
                                fb_event_click: e.target.value,
                              },
                            });
                          }
                        }}
                        name="fb_event_click"
                        adorment={` ${
                          val.extra?.fb_event_click
                            ? val.extra?.fb_event_click.length
                            : 0
                        }/ 40자`}
                      />
                    </Box>
                  </Grid>
                </>
              ) : val.ad_type == 9 ? (
                <>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="텍스트 1 (강조)" />
                      <Grid container spacing={1}>
                        <Grid item xs={9}>
                          <OutlinedInputDefault
                            value={val.extra?.texts?.[0]?.text || ""}
                            onChange={(e) =>
                              setVal({
                                ...val,
                                extra: {
                                  ...val.extra,
                                  texts: [
                                    { text: e.target.value, color: val.extra?.texts?.[0]?.color || "#F46281" },
                                    val.extra?.texts?.[1] || { text: "", color: "#000" },
                                  ],
                                },
                              })
                            }
                            name="text1"
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <OutlinedInputDefault
                            value={val.extra?.texts?.[0]?.color || "#F46281"}
                            onChange={(e) =>
                              setVal({
                                ...val,
                                extra: {
                                  ...val.extra,
                                  texts: [
                                    { text: val.extra?.texts?.[0]?.text || "", color: e.target.value },
                                    val.extra?.texts?.[1] || { text: "", color: "#000" },
                                  ],
                                },
                              })
                            }
                            name="color1"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="텍스트 2" />
                      <Grid container spacing={1}>
                        <Grid item xs={9}>
                          <OutlinedInputDefault
                            value={val.extra?.texts?.[1]?.text || ""}
                            onChange={(e) =>
                              setVal({
                                ...val,
                                extra: {
                                  ...val.extra,
                                  texts: [
                                    val.extra?.texts?.[0] || { text: "", color: "#F46281" },
                                    { text: e.target.value, color: val.extra?.texts?.[1]?.color || "#000" },
                                  ],
                                },
                              })
                            }
                            name="text2"
                            multiline
                            minRows={2}
                            maxRows={4}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <OutlinedInputDefault
                            value={val.extra?.texts?.[1]?.color || "#000"}
                            onChange={(e) =>
                              setVal({
                                ...val,
                                extra: {
                                  ...val.extra,
                                  texts: [
                                    val.extra?.texts?.[0] || { text: "", color: "#F46281" },
                                    { text: val.extra?.texts?.[1]?.text || "", color: e.target.value },
                                  ],
                                },
                              })
                            }
                            name="color2"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                  <Grid container sx={{ mb: 3 }}>
                    <Grid item xs={6} sx={{ pr: 1 }}>
                      <DefaultLabel name="나이 (시작)" />
                      <OutlinedInputDefault
                        inputType="number"
                        value={val.extra?.params?.age?.[0] ?? 0}
                        onChange={(e) =>
                          setVal({
                            ...val,
                            extra: {
                              ...val.extra,
                              params: {
                                ...val.extra?.params,
                                age: [Number(e.target.value), val.extra?.params?.age?.[1] ?? 15],
                              },
                            },
                          })
                        }
                        name="age_start"
                      />
                    </Grid>
                    <Grid item xs={6} sx={{ pl: 1 }}>
                      <DefaultLabel name="나이 (끝)" />
                      <OutlinedInputDefault
                        inputType="number"
                        value={val.extra?.params?.age?.[1] ?? 15}
                        onChange={(e) =>
                          setVal({
                            ...val,
                            extra: {
                              ...val.extra,
                              params: {
                                ...val.extra?.params,
                                age: [val.extra?.params?.age?.[0] ?? 0, Number(e.target.value)],
                              },
                            },
                          })
                        }
                        name="age_end"
                      />
                    </Grid>
                  </Grid>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="대상 스크린" />
                      <FormControl fullWidth>
                        <Select
                          value={val.extra?.screen || ""}
                          onChange={(e) =>
                            setVal({
                              ...val,
                              extra: { ...val.extra, screen: e.target.value },
                            })
                          }
                          size="small"
                          sx={{ height: 41 }}
                        >
                          {AdFilter[9]?.map((data) => (
                            <MenuItem key={data.id} value={data.id}>
                              <Typography variant="body2">{data.text}</Typography>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="증상 조건" />
                      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                        <Checkbox
                          checked={val.extra?.params?.symptom === "*"}
                          onChange={(e) => {
                            setVal({
                              ...val,
                              extra: {
                                ...val.extra,
                                params: {
                                  ...val.extra?.params,
                                  symptom: e.target.checked ? "*" : [],
                                },
                              },
                            });
                          }}
                          size="small"
                        />
                        <Typography variant="body2" fontWeight={600}>전체 (모든 증상)</Typography>
                      </Box>
                      {val.extra?.params?.symptom !== "*" && (
                        <FormControl fullWidth>
                          <Select
                            multiple
                            value={Array.isArray(val.extra?.params?.symptom) ? val.extra.params.symptom : []}
                            onChange={(e) => {
                              setVal({
                                ...val,
                                extra: {
                                  ...val.extra,
                                  params: {
                                    ...val.extra?.params,
                                    symptom: e.target.value,
                                  },
                                },
                              });
                            }}
                            renderValue={(selected) => {
                              if (selected.length === 0) return "증상을 선택하세요";
                              return SymptomList
                                .filter((s) => selected.includes(s.id))
                                .map((s) => s.text)
                                .join(", ");
                            }}
                            size="small"
                            sx={{ height: 41 }}
                            MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                          >
                            {SymptomList.map((symptom) => (
                              <MenuItem key={symptom.id} value={symptom.id}>
                                <Checkbox checked={Array.isArray(val.extra?.params?.symptom) && val.extra.params.symptom.includes(symptom.id)} size="small" />
                                <Typography variant="body2">{symptom.text}</Typography>
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </Box>
                  </Grid>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="질병 조건" />
                      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                        <Checkbox
                          checked={val.extra?.params?.diseases === "*"}
                          onChange={(e) => {
                            setVal({
                              ...val,
                              extra: {
                                ...val.extra,
                                params: {
                                  ...val.extra?.params,
                                  diseases: e.target.checked ? "*" : [],
                                },
                              },
                            });
                          }}
                          size="small"
                        />
                        <Typography variant="body2" fontWeight={600}>전체 (모든 질병)</Typography>
                      </Box>
                      {val.extra?.params?.diseases !== "*" && (
                        <FormControl fullWidth>
                          <Select
                            multiple
                            value={Array.isArray(val.extra?.params?.diseases) ? val.extra.params.diseases : []}
                            onChange={(e) => {
                              setVal({
                                ...val,
                                extra: {
                                  ...val.extra,
                                  params: {
                                    ...val.extra?.params,
                                    diseases: e.target.value,
                                  },
                                },
                              });
                            }}
                            renderValue={(selected) => {
                              if (selected.length === 0) return "질병을 선택하세요";
                              return DiseaseList
                                .filter((d) => selected.includes(d.id))
                                .map((d) => d.text)
                                .join(", ");
                            }}
                            size="small"
                            sx={{ height: 41 }}
                            MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                          >
                            {DiseaseList.map((disease) => (
                              <MenuItem key={disease.id} value={disease.id}>
                                <Checkbox checked={Array.isArray(val.extra?.params?.diseases) && val.extra.params.diseases.includes(disease.id)} size="small" />
                                <Typography variant="body2">{disease.text}</Typography>
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </Box>
                  </Grid>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="버튼 텍스트" />
                      <OutlinedInputDefault
                        value={val.extra?.btn_text || ""}
                        onChange={(e) =>
                          setVal({
                            ...val,
                            extra: { ...val.extra, btn_text: e.target.value },
                          })
                        }
                        name="btn_text"
                      />
                    </Box>
                  </Grid>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="URL" />
                      <OutlinedInputRightAdornment
                        value={val.banners[index].link_url}
                        onChange={(e) =>
                          setVal({
                            ...val,
                            banners: val.banners.map((data, i) => {
                              return i === index
                                ? { ...val.banners[i], link_url: e.target.value }
                                : data;
                            }),
                          })
                        }
                        name={"Android"}
                        adorment={"Android"}
                        krName={"Android"}
                        disabled={!adminValueCheck(value.user.ADMIN)}
                      />
                      <Grid sx={{ mt: 0.625, mb: 1.25 }}></Grid>
                      <OutlinedInputRightAdornment
                        value={val.banners[index].link_url_i}
                        onChange={(e) =>
                          setVal({
                            ...val,
                            banners: val.banners.map((data, i) => {
                              return i === index
                                ? { ...val.banners[i], link_url_i: e.target.value }
                                : data;
                            }),
                          })
                        }
                        name={"IOS"}
                        adorment={"IOS"}
                        krName={"IOS"}
                        disabled={!adminValueCheck(value.user.ADMIN)}
                      />
                    </Box>
                  </Grid>
                </>
              ) : (
                <>
                  {val.ad_type == 7 || val.ad_type == 8 || val.ad_type == 13 || val.ad_type == 14 || val.ad_type == 15 ? null : (
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Grid>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <IconButton
                            aria-label="prev"
                            // size="small"
                            disabled={index + 1 <= 1 ? true : false}
                            onClick={() => handleBannerTargetChange("prev")}
                          >
                            <ArrowBackIosIcon />
                          </IconButton>
                          <IconButton
                            aria-label="next"
                            // size="small"
                            disabled={
                              val.banners.length <= index + 1 ? true : false
                            }
                            onClick={() => handleBannerTargetChange("next")}
                          >
                            <ArrowForwardIosIcon />
                          </IconButton>
                        </Stack>
                      </Grid>
                      <Grid>
                        <GreyLightButton
                          sx={{ mr: 1, height: 28 }}
                          onClick={handleBannerAdd}
                          disabled={!adminValueCheck(value.user.ADMIN)}
                        >
                          추가
                        </GreyLightButton>

                        <GreyLightButton
                          sx={{ mr: 1, height: 28 }}
                          onClick={handleBannerDelete}
                          disabled={!adminValueCheck(value.user.ADMIN)}
                        >
                          삭제
                        </GreyLightButton>
                      </Grid>
                    </Grid>
                  )}
                  <label
                    htmlFor="contained-button-file"
                    style={{
                      width: val.ad_type == 7 || val.ad_type == 8 || val.ad_type == 13 || val.ad_type == 14 || val.ad_type == 15 ? "127px" : "100%",
                    }}
                  >
                    {adminValueCheck(value.user.ADMIN) && (
                      <Input
                        accept="image/*"
                        id="contained-button-file"
                        multiple
                        type="file"
                        ref={inputRef}
                        onChange={handleAddImage}
                      />
                    )}

                    {val.banners[index] && val.banners[index].img_url ? (
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          height: 127,
                          mt: 2,
                          mb: 2,
                          backgroundColor: "#bebebe",
                          border: "1px solid #c4c4c4",
                          backgroundImage: `url(${val.banners[index].img_url})`,
                          backgroundSize: "cover",
                          backgroundPosition: "50% 50%",
                          backgroundRepeat: "no-repeat",
                        }}
                      ></Grid>
                    ) : (
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          height: 127,
                          mt: 2,
                          mb: 2,
                          backgroundColor: "#bebebe",
                          border: "1px solid #c4c4c4",
                        }}
                      ></Grid>
                    )}
                  </label>

                  <Box sx={{ mb: 2, width: "100%" }}>
                    <DefaultLabel name="이미지명" />
                    <OutlinedInputRightAdornment
                      value={
                        val.banners[index].img_name
                          ? val.banners[index].img_name
                          : ""
                      }
                      onChange={(e) => {
                        if (e.target.value.length > 100) {
                        } else {
                          setVal({
                            ...val,
                            banners: val.banners.map((data, i) => {
                              return i === index
                                ? {
                                    ...val.banners[i],
                                    img_name: e.target.value,
                                  }
                                : data;
                            }),
                          });
                        }
                      }}
                      name="android"
                      adorment={` ${
                        val.banners[index].img_name
                          ? val.banners[index].img_name.length
                          : 0
                      }/ 100자`}
                      disabled={!adminValueCheck(value.user.ADMIN)}
                    />
                  </Box>
                </>
              )}
              {val.ad_type == 6 || val.ad_type == 9 ? null : val.ad_type == 8 ? (
                <UrlInputByOpenType
                  key={`url-dialog-${index}-${val.banners[index].open_type}`}
                  openType={val.banners[index].open_type}
                  linkUrl={val.banners[index].link_url}
                  linkUrlI={val.banners[index].link_url_i}
                  onOpenTypeChange={() => {}}
                  onUrlChange={(url, urlI) =>
                    setVal({
                      ...val,
                      banners: val.banners.map((data, i) => {
                        return i === index
                          ? { ...val.banners[i], link_url: url, link_url_i: urlI }
                          : data;
                      }),
                    })
                  }
                  disabled={!adminValueCheck(value.user.ADMIN)}
                />
              ) : OpenType[String(val.ad_type)]?.length > 0 ? (
                <UrlInputByOpenType
                  key={`url-dialog-${index}-${val.banners[index].open_type}`}
                  openType={val.banners[index].open_type}
                  openTypeList={OpenType[String(val.ad_type)]}
                  linkUrl={val.banners[index].link_url}
                  linkUrlI={val.banners[index].link_url_i}
                  onOpenTypeChange={(newType) =>
                    setVal({
                      ...val,
                      banners: val.banners.map((data, i) => {
                        if (i !== index) return data;
                        return { ...data, open_type: newType, link_url: "", link_url_i: "" };
                      }),
                    })
                  }
                  onUrlChange={(url, urlI) =>
                    setVal({
                      ...val,
                      banners: val.banners.map((data, i) => {
                        return i === index
                          ? { ...val.banners[i], link_url: url, link_url_i: urlI }
                          : data;
                      }),
                    })
                  }
                  disabled={!adminValueCheck(value.user.ADMIN)}
                />
              ) : (
                <Box sx={{ mb: 2, width: "100%" }}>
                  <DefaultLabel
                    name={val.ad_type == 7 ? "혜택탭 url" : "url"}
                  />
                  <OutlinedInputRightAdornment
                    value={val.banners[index].link_url}
                    onChange={(e) =>
                      setVal({
                        ...val,
                        banners: val.banners.map((data, i) => {
                          return i === index
                            ? {
                                ...val.banners[i],
                                link_url: e.target.value,
                              }
                            : data;
                        }),
                      })
                    }
                    name="android"
                    adorment={`Android`}
                    disabled={!adminValueCheck(value.user.ADMIN)}
                  />
                  <Box sx={{ mt: 0.625, mb: 0.625 }}></Box>
                  <OutlinedInputRightAdornment
                    value={val.banners[index].link_url_i}
                    onChange={(e) =>
                      setVal({
                        ...val,
                        banners: val.banners.map((data, i) => {
                          return i === index
                            ? {
                                ...val.banners[i],
                                link_url_i: e.target.value,
                              }
                            : data;
                        }),
                      })
                    }
                    name="ios"
                    adorment={`IOS`}
                    disabled={!adminValueCheck(value.user.ADMIN)}
                  />
                </Box>
              )}
              {val.ad_type != 7 ? null : (
                <Box sx={{ mb: 2, width: "100%" }}>
                  <Grid
                    container
                    justifyContent="space-between"
                    sx={{ width: "100%" }}
                  >
                    <DefaultLabel name={"열관리탭 url"} />
                    <Box style={{ display: "flex", flexDirection: "row" }}>
                      <DefaultLabel name={"활성"} />
                      <Checkbox
                        checked={!val.extra?.position?.fever_tab?.disabled}
                        onChange={(e) => setVal({
                          ...val,
                          extra: {
                            ...(val.extra || {}),
                            position: {
                              ...(val.extra?.position || {}),
                              fever_tab: {
                                ...(val.extra?.position?.fever_tab || {}),
                                disabled: !e.target.checked,
                              },
                            },
                          },
                        })}
                        sx={{
                          p: 0,
                          "& .MuiSvgIcon-root": { fontSize: 22 },
                        }}
                      />
                    </Box>
                  </Grid>
                  <OutlinedInputRightAdornment
                    value={val.extra?.position?.fever_tab?.url || ""}
                    onChange={(e) =>
                      setVal({
                        ...val,
                        extra: {
                          ...(val.extra || {}),
                          position: {
                            ...(val.extra?.position || {}),
                            fever_tab: {
                              ...(val.extra?.position?.fever_tab || {}),
                              url: e.target.value,
                            },
                          },
                        },
                      })
                    }
                    name="android"
                    adorment={`Android`}
                    disabled={!adminValueCheck(value.user.ADMIN)}
                  />
                  <Box sx={{ mt: 0.625, mb: 0.625 }}></Box>
                  <OutlinedInputRightAdornment
                    value={val.extra?.position?.fever_tab?.url_i || ""}
                    onChange={(e) =>
                      setVal({
                        ...val,
                        extra: {
                          ...(val.extra || {}),
                          position: {
                            ...(val.extra?.position || {}),
                            fever_tab: {
                              ...(val.extra?.position?.fever_tab || {}),
                              url_i: e.target.value,
                            },
                          },
                        },
                      })
                    }
                    name="ios"
                    adorment={`IOS`}
                    disabled={!adminValueCheck(value.user.ADMIN)}
                  />
                </Box>
              )}
              {(val.ad_type == 6 || val.ad_type == 9) && OpenType[String(val.ad_type)]?.length > 0 ? (
                <Box sx={{ mb: 2, width: "100%" }}>
                  <DefaultLabel name="오픈 방식" />
                  <FormControl fullWidth>
                    <Select
                      labelId="open_type"
                      id="open_type"
                      align="left"
                      size="small"
                      sx={{ height: 41 }}
                      value={val.banners[index].open_type}
                      onChange={(e) =>
                        setVal({
                          ...val,
                          banners: val.banners.map((data, i) => {
                            return i === index
                              ? {
                                  ...val.banners[i],
                                  open_type: e.target.value,
                                }
                              : data;
                          }),
                        })
                      }
                    >
                      {OpenType[String(val.ad_type)]?.map((data, index) => (
                        <MenuItem value={data.id} key={data.id}>
                          <Typography
                            variant="body"
                            color="grey.900"
                            fontWeight={400}
                          >
                            {data.text}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              ) : null}
              {val.ad_type == 4 || val.ad_type == 5 || val.ad_type == 7 || val.ad_type == 8 || val.ad_type == 9 || val.ad_type == 13 || val.ad_type == 14 || val.ad_type == 15 ? (
                <Box />
              ) : (
                <Grid container justifyContent="center" alignItems="center">
                  {val.banners.map((data, i) => {
                    return (
                      <img
                        key={i}
                        onClick={() => setIndex(i)}
                        src={
                          index === i
                            ? images.inc_circle_on.default
                            : images.inc_circle_off.default
                        }
                        alt="right_arrow"
                        style={{ marginRight: 8, cursor: "pointer" }}
                      />
                    );
                  })}
                </Grid>
              )}
            </Item>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ mt: 0 }}
        >
          <Button
            variant="outlined"
            fullWidth={false}
            onClick={() => onADDELETE(val.ad_id)}
            sx={{
              height: 56,
              width: 210,
              mr: 1.25,
              boxShadow: 0,
              "&:hover": {
                boxShadow: 0,
              },
            }}
          >
            <Typography variant="h3" fontWeight={500}>
              삭제
            </Typography>
          </Button>
          {adminValueCheck(value.user.ADMIN) && (
            <Button
              variant="contained"
              fullWidth={false}
              onClick={handleUpdate}
              sx={{
                height: 56,
                width: 210,
                ml: 1.25,
                boxShadow: 0,
                "&:hover": {
                  boxShadow: 0,
                },
              }}
            >
              <Typography variant="h3" fontWeight={500}>
                수정완료
              </Typography>
            </Button>
          )}
        </Grid>
      </Box>
    </Modal>
  );
};

export default AdDialog;
